import axios from 'axios';

import {API_URL} from './constants';

const getSessionAudit = async (sessionId: string) => {
    const response = await axios.get(`${API_URL}/session-audit/${sessionId}`);
    return response.data;
};

export const sessionAuditApi = {
    getSessionAudit
};
